module.exports = __webpack_public_path__ + "img/NF.40f4137c.svg";